import React from "react";
import { interfaceTask } from "../interface";

interface Props {
    task: interfaceTask;
    completeTask(taskNameDelete: string): void;
}
const TodoTask = ({ task, completeTask }: Props) => {
        return (
        <div className="task">
                <div className="content">
                    <div className="title">
                        <span><h2>{task.taskName}</h2></span>
                        <button onClick={() => { completeTask(task.taskName); }}>X</button>
                    </div>
                    <span>{!task.description ? null : <p>{task.description}</p>}</span>                
                </div>    
        </div>
        
    );
};

export default TodoTask;